import { render, staticRenderFns } from "./delete-user.vue?vue&type=template&id=54418f68&scoped=true&"
import script from "./delete-user.vue?vue&type=script&lang=tsx&"
export * from "./delete-user.vue?vue&type=script&lang=tsx&"
import style0 from "./delete-user.vue?vue&type=style&index=0&id=54418f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54418f68",
  null
  
)

export default component.exports